import { TFunction } from 'i18next'

import { HTTP_PROTOCOL_REGEX } from '@/constants/regex'

import { getServiceLabelMap } from './social-links.constants'
import { SocialLinkFormData } from './social-links.types'

export const getLinkHref = (link: string) => {
  if (HTTP_PROTOCOL_REGEX.test(link)) return link

  return `https://${link}`
}

export const getServiceLabel = (
  service: SocialLinkFormData['service'],
  t: TFunction<['communication']>,
) => {
  return getServiceLabelMap(t)[service]
}

export const formatRowInfo = (
  service: SocialLinkFormData['service'],
  link: string,
  t: TFunction<['communication']>,
) => {
  return `${getServiceLabel(service, t)} | ${link}`
}
